import { useEffect, useState } from "react";
import AdminPageLayout from "../../../components/midpoint/admin/layout/AdminPageLayout";
import AdminPageHeader from "../../../components/midpoint/admin/layout/AdminPageHeader";
import { AdminAutomotiveNav } from "../automotive/AdminAutomotiveNav";
import { ANALYTICS_DATE_RANGES } from "../../../constants/buyerAnalyticsConstants";
import { fetchSearchAnalytics } from "../../../services/automapBuyerAnalyticsApi";
import {
  AdminAnalyticsNav,
  AnalyticsBreakdownTable,
  AnalyticsRangeSelect,
  AnalyticsSummaryGrid,
} from "./AdminAnalyticsShared";

export default function AdminSearchAnalyticsPage() {
  const [range, setRange] = useState("last_30_days");
  const [payload, setPayload] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    setLoading(true);
    setError("");
    fetchSearchAnalytics(range)
      .then(setPayload)
      .catch((err) => setError(err.message || "Error al cargar búsqueda."))
      .finally(() => setLoading(false));
  }, [range]);

  const totals = payload?.totals;

  return (
    <AdminPageLayout>
      <AdminPageHeader
        eyebrow="AutoMapa · Analytics"
        title="Analytics de búsqueda"
        description="Términos, filtros, ciudades y clics desde resultados."
      />
      <AdminAutomotiveNav active="analytics" />
      <AdminAnalyticsNav active="search" />
      <main className="admin-console__main wrap">
        <div className="dealer-inventory-toolbar">
          <AnalyticsRangeSelect range={range} onChange={setRange} options={ANALYTICS_DATE_RANGES} />
        </div>
        {loading ? <p className="dealer-state-box">Cargando…</p> : null}
        {error ? <p className="dealer-state-box">{error}</p> : null}
        {!loading && !error && totals ? (
          <>
            <AnalyticsSummaryGrid
              items={[
                { label: "Búsquedas", value: totals.searches },
                { label: "Sin resultados", value: totals.noResults },
                { label: "Cambios de filtro", value: totals.filterChanges },
                { label: "Clics en cards", value: totals.cardClicks },
              ]}
            />
            <div className="admin-analytics-grid">
              <AnalyticsBreakdownTable title="Top ciudades" rows={payload.topCities} />
              <AnalyticsBreakdownTable title="Top marcas" rows={payload.topMakes} />
              <AnalyticsBreakdownTable title="Top filtros" rows={payload.topFilters} keyLabel="Filtro" />
              <AnalyticsBreakdownTable title="Búsquedas sin resultados" rows={payload.noResultQueries} keyLabel="Query" />
              <AnalyticsBreakdownTable title="Listings más clicados" rows={payload.topClickedListings} keyLabel="Listing" />
            </div>
          </>
        ) : null}
      </main>
    </AdminPageLayout>
  );
}
